export enum TOS_REQUEST_IDENTIFIERS {
  'FEATURES' = 'tos.features'
}
